import type {
  AnalyticsOverviewDto,
  EventAnalyticsSettings,
  ExhibitorAnalyticsDto,
  ExhibitorCompanyAccessDto,
  EventStatsPeriod,
  GrantExhibitorPortalInput,
  GrantExhibitorPortalResponse,
  VisitorAnalyticsDto,
} from "@mvk/shared";
import { apiRequest } from "../api/client";

export const adminAnalyticsApi = {
  getOverview(eventId: string, period: EventStatsPeriod = "event") {
    return apiRequest<{ overview: AnalyticsOverviewDto }>(
      `/events/${eventId}/analytics/overview?period=${period}`,
      { audience: "admin" },
    );
  },

  getSettings(eventId: string) {
    return apiRequest<{ settings: EventAnalyticsSettings }>(
      `/events/${eventId}/analytics/settings`,
      { audience: "admin" },
    );
  },

  patchSettings(eventId: string, exhibitorAnalyticsEnabled: boolean) {
    return apiRequest<{ settings: EventAnalyticsSettings }>(
      `/events/${eventId}/analytics/settings`,
      {
        method: "PATCH",
        body: { exhibitorAnalyticsEnabled },
        audience: "admin",
      },
    );
  },

  getExhibitor(eventId: string, companyId?: string) {
    const q = companyId ? `?companyId=${encodeURIComponent(companyId)}` : "";
    return apiRequest<{ analytics: ExhibitorAnalyticsDto }>(
      `/events/${eventId}/analytics/exhibitor${q}`,
      { audience: "admin" },
    );
  },

  getVisitor(eventId: string, userId: string) {
    return apiRequest<{ analytics: VisitorAnalyticsDto }>(
      `/events/${eventId}/analytics/visitors/${encodeURIComponent(userId)}`,
      { audience: "admin" },
    );
  },

  getCompanyAccess(eventId: string, companyId: string) {
    return apiRequest<{ access: ExhibitorCompanyAccessDto }>(
      `/events/${eventId}/companies/${companyId}/access`,
      { audience: "admin" },
    );
  },

  patchCompanyAccess(eventId: string, companyId: string, analyticsEnabled: boolean) {
    return apiRequest<{ access: ExhibitorCompanyAccessDto }>(
      `/events/${eventId}/companies/${companyId}/access`,
      {
        method: "PATCH",
        body: { analyticsEnabled },
        audience: "admin",
      },
    );
  },

  grantPortal(
    eventId: string,
    companyId: string,
    payload: GrantExhibitorPortalInput & { enableAnalytics?: boolean },
  ) {
    return apiRequest<{ portal: GrantExhibitorPortalResponse }>(
      `/events/${eventId}/companies/${companyId}/portal`,
      {
        method: "POST",
        body: payload,
        audience: "admin",
      },
    );
  },
};
